<template>
  <SectionWrapper sectionId="pickup">
    <SectionContainer>
      <div class="pickup_header">
        <img :src="headingData.img">
      </div>
      <ContentContainer>
        <div v-if="isMobile().phone" class="pickup_container">
          <hooper :settings="hooperSettings">
            <slide v-for="(pickup, index) in pickupList" :key="index">
              <NewsCard
                class="pickup_item"
                :imgSrc="pickup['media:thumbnail']"
                :title="pickup.title"
                :publishIsoDate="pickup.isoDate"
                :link="pickup.link"
                :description="pickup.description" />
            </slide>
            <HooperNavigation slot="hooper-addons"></HooperNavigation>
            <HooperPagination slot="hooper-addons"></HooperPagination>
          </hooper>
        </div>
        <div v-else class="pickup_container">
          <NewsCard v-for="(pickup, index) in pickupList" :key="index"
                         class="pickup_item"
                         :imgSrc="pickup['media:thumbnail']"
                         :title="pickup.title"
                         :publishIsoDate="pickup.isoDate"
                         :link="pickup.link"
                         :description="pickup.description" />
        </div>
      </ContentContainer>
    </SectionContainer>
  </SectionWrapper>
</template>

<script>
import SectionWrapper from '../atoms/SectionWrapper'
import SectionContainer from '../atoms/SectionContainer'
import ContentContainer from '../atoms/ContentContainer'
import NewsCard from '../atoms/NewsCard'
import { News as NewsFunction } from '../../functions/news'
import isMobile from 'ismobilejs'
import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper'

export default {
  name: 'pickup',
  components: {
    SectionWrapper,
    SectionContainer,
    ContentContainer,
    NewsCard,
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation
  },
  data () {
    return {
      headingData: {
        img: require('@/assets/images/pickup_txt.svg'),
        text: 'Pickup'
      },
      pickupList: [],
      isMobile,
      hooperSettings: {
        autoPlay: true,
        infiniteScroll: true,
        centerMode: true,
        wheelControl: false,
        playSpeed: 10000
      }
    }
  },
  async mounted () {
    const pickupList = await NewsFunction.getPickup()
    this.pickupList = pickupList.sort((a, b) => {
      if (a.isoDate === b.isoDate) return 0
      return a.isoDate > b.isoDate ? -1 : 1
    })
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.pickup {
  &_header {
    width: 100%;
    align-items: center;

    @include bpOnlyPc() {
      height: 56px;
    }
    @include bpOnlySp() {
      height: 46px;
    }

    img {
      height: 100%;
      width: 100%;
    }
  }
  &_container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    @include bpOnlyPc() {
      overflow-x: scroll;
    }
    @include bpOnlySp() {
      flex-direction: column;
      align-items: center;
    }
  }
  &_item {
    align-items: center;
    padding: 10px;
    margin: 0 auto;
  }
  &_link {
    @include bpOnlyPc() {
      font-size: 20px;
    }
    @include bpOnlySp() {
      font-size: 15px;
    }
    text-align: right;
    font-weight: bold;
    line-height: 1.4;
    letter-spacing: 0.1em;
    margin-bottom: 20px;
  }
}

.hooper {
  height: 100%;
}
</style>
